"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ClickOutside = _interopRequireDefault(require("../ClickOutside"));
var _Popup = _interopRequireDefault(require("../Popup"));
var _Container = _interopRequireDefault(require("../Container"));
var _useMedia = _interopRequireDefault(require("../../hooks/useMedia"));
var _IconAppMenu = _interopRequireDefault(require("./IconAppMenu"));
var _IconBusinessProfile = _interopRequireDefault(require("./IconBusinessProfile"));
var _IconLsOnline = _interopRequireDefault(require("./IconLsOnline"));
var _IconLocalGPT = _interopRequireDefault(require("./IconLocalGPT"));
var _Text = _interopRequireDefault(require("../Text"));
var _Anchor = _interopRequireDefault(require("../Anchor"));
var _IconUserManagement = _interopRequireDefault(require("./IconUserManagement"));
var _IconWebsiteThemes = _interopRequireDefault(require("./IconWebsiteThemes"));
var _IconPerformio = _interopRequireDefault(require("./IconPerformio"));
var _IconStaffPortal = _interopRequireDefault(require("./IconStaffPortal"));
var _IconSalesToolkit = _interopRequireDefault(require("./IconSalesToolkit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const envUrls = {
  development: {
    localsearchOnline: 'https://development.ls-www.localsearch.cloud',
    localGPT: 'https://ls-local-gpt-client.development.localsearch.cloud',
    localsearchBusinessProfile: 'https://development.ls-business-profile.localsearch.cloud',
    accountSettings: 'https://development.ls-user.localsearch.cloud',
    websiteThemes: 'https://websitethemes.localsearch.com.au',
    performio: 'https://localsearch.performio.co/Login.do',
    addAProfile: 'https://development.ls-business-profile.localsearch.cloud/create-profile',
    salesToolkit: 'https://development.ls-sales-toolkit.localsearch.cloud'
  },
  staging: {
    localsearchOnline: 'https://staging.ls-www.localsearch.cloud',
    localGPT: 'https://ls-local-gpt-client.staging.localsearch.cloud',
    localsearchBusinessProfile: 'https://staging.ls-business-profile.localsearch.cloud',
    accountSettings: 'https://staging.ls-user.localsearch.cloud',
    websiteThemes: 'https://websitethemes.localsearch.com.au',
    performio: 'https://localsearch.performio.co/Login.do',
    addAProfile: 'https://staging.ls-business-profile.localsearch.cloud/create-profile',
    salesToolkit: 'https://staging.ls-sales-toolkit.localsearch.cloud'
  },
  production: {
    localsearchOnline: 'https://www.localsearch.com.au',
    localGPT: 'https://gpt.localsearch.com.au',
    localsearchBusinessProfile: 'https://business-profile.localsearch.com.au',
    accountSettings: 'https://account.localsearch.com.au',
    websiteThemes: 'https://websitethemes.localsearch.com.au',
    performio: 'https://localsearch.performio.co/Login.do',
    addAProfile: 'https://business-profile.localsearch.com.au/create-profile',
    salesToolkit: 'https://sales-toolkit.localsearch.com.au'
  }
};
const StyledButton = _styledComponents.default.button.withConfig({
  displayName: "AppMenu__StyledButton",
  componentId: "sc-1o7p3ih-0"
})(["display:flex;align-items:center;cursor:pointer;padding:0;transition:all ease 0.3s;background:none;border:none;width:100%;height:100%;&:focus{outline:none;}"]);
const StyledAnchor = (0, _styledComponents.default)(_Anchor.default).withConfig({
  displayName: "AppMenu__StyledAnchor",
  componentId: "sc-1o7p3ih-1"
})(["text-align:center;display:flex;align-items:center;justify-content:center;cursor:pointer;flex:0 0 33.3333%;padding:0 5px;margin-top:15px;margin-bottom:15px;flex-direction:column;border:none;background:none;&:hover span{color:", ";}"], props => props.theme.primary.normal);
const AppMenu = ({
  iconFill,
  iconFillActive,
  hide,
  env,
  onOpen,
  onClose,
  isStaff,
  isPersoniv,
  ...props
}) => {
  const [show, setShow] = (0, _react.useState)(false);
  const [buttonHover, setButtonHover] = (0, _react.useState)(false);
  const [popupHeight, setPopupHeight] = (0, _react.useState)();
  const popupRef = (0, _react.useRef)();
  const theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  const {
    mobile
  } = (0, _useMedia.default)(theme.mediaQueries);
  const links = envUrls[env] || envUrls.production;
  (0, _react.useEffect)(() => {
    if (show) {
      const {
        top,
        height
      } = popupRef.current.getBoundingClientRect();
      const maxHeight = window.innerHeight - top;
      if (height > maxHeight) {
        setPopupHeight(`${maxHeight}px`);
      }
    } else {
      setPopupHeight('auto');
    }
  }, [show]);
  const menuItems = (0, _react.useMemo)(() => {
    const items = [{
      text: 'Localsearch',
      icon: /*#__PURE__*/_react.default.createElement(_IconLsOnline.default, null),
      href: links.localsearchOnline
    }, {
      text: 'Localsearch for Business',
      icon: /*#__PURE__*/_react.default.createElement(_IconBusinessProfile.default, null),
      href: links.localsearchBusinessProfile
    }, ...(isStaff || isPersoniv ? [{
      text: 'Add a Profile',
      icon: /*#__PURE__*/_react.default.createElement(_IconStaffPortal.default, null),
      href: links.addAProfile
    }] : []), ...(isStaff ? [{
      text: 'Local GPT',
      icon: /*#__PURE__*/_react.default.createElement(_IconLocalGPT.default, null),
      href: links.localGPT
    }] : []), ...(isStaff ? [{
      text: 'Sales Toolkit',
      icon: /*#__PURE__*/_react.default.createElement(_IconSalesToolkit.default, null),
      href: links.salesToolkit
    }] : []), ...(isStaff ? [{
      text: 'Website Themes',
      icon: /*#__PURE__*/_react.default.createElement(_IconWebsiteThemes.default, null),
      href: links.websiteThemes
    }] : []), ...(isStaff ? [{
      text: 'Performio',
      icon: /*#__PURE__*/_react.default.createElement(_IconPerformio.default, null),
      href: links.performio
    }] : []), {
      text: 'Account Settings',
      icon: /*#__PURE__*/_react.default.createElement(_IconUserManagement.default, null),
      href: links.accountSettings
    }];
    return items.filter(({
      hidden
    }) => !hidden);
  }, [isStaff, isPersoniv, links]);
  return /*#__PURE__*/_react.default.createElement(_ClickOutside.default, _extends({
    onClickOutside: () => {
      setShow(false);
      if (show) {
        onClose();
      }
    }
  }, props), /*#__PURE__*/_react.default.createElement(StyledButton, {
    onMouseEnter: () => setButtonHover(true),
    onMouseLeave: () => setButtonHover(false),
    onClick: () => {
      setShow(!show);
      onOpen();
    },
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_IconAppMenu.default, {
    width: "100%",
    fill: buttonHover || show ? iconFillActive : iconFill
  })), /*#__PURE__*/_react.default.createElement(_Popup.default, {
    show: show,
    width: mobile ? 'calc(100vw - 20px)' : '420px',
    minWidth: "auto",
    top: "auto",
    position: mobile ? 'fixed' : 'absolute',
    left: mobile ? '10px' : 'auto',
    right: mobile ? '10px' : '0',
    bottom: "unset",
    marginTop: "12px",
    anchor: "topRight",
    height: popupHeight || 'auto',
    overflow: "auto",
    ref: popupRef
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    padding: mobile ? '30px 10px 10px 10px' : '30px 30px 10px 30px',
    display: "flex",
    justContent: "center",
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textAlign: "center",
    color: "normal",
    fontSize: "20px",
    fontFamily: "circular",
    fontWeight: "bold",
    marginBottom: "10px",
    width: "100%",
    lineHeight: "1.2"
  }, "Your Localsearch Suite"), /*#__PURE__*/_react.default.createElement(_Container.default, {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, menuItems.map(({
    icon,
    text,
    href
  }) => {
    if (hide.includes(text)) return null;
    return /*#__PURE__*/_react.default.createElement(StyledAnchor, {
      key: text,
      href: href,
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(_Container.default, {
      maxWidth: "94px",
      width: "100%"
    }, icon), /*#__PURE__*/_react.default.createElement(_Text.default, {
      lineHeight: "1.3",
      marginTop: "10px",
      color: "normal",
      fontFamily: "circular",
      fontWeight: "600",
      fontSize: "14px",
      transition: "all 0.3s ease"
    }, text));
  })))));
};
__signature__(AppMenu, "useState{[show, setShow](false)}\nuseState{[buttonHover, setButtonHover](false)}\nuseState{[popupHeight, setPopupHeight]}\nuseRef{popupRef}\nuseContext{theme}\nuseMedia{{ mobile }}\nuseEffect{}\nuseMemo{menuItems}", () => [_useMedia.default]);
AppMenu.propTypes = {
  iconFill: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  iconFillActive: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  hide: _propTypes.default.arrayOf(_propTypes.default.string),
  env: _propTypes.default.string,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  isStaff: _propTypes.default.bool,
  isPersoniv: _propTypes.default.bool
};
AppMenu.defaultProps = {
  iconFill: 'white',
  iconFillActive: '#97AEFF',
  hide: [],
  env: 'production',
  onOpen: () => {},
  onClose: () => {},
  isStaff: false,
  isPersoniv: false
};
const _default = AppMenu;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(envUrls, "envUrls", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/index.js");
  reactHotLoader.register(StyledButton, "StyledButton", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/index.js");
  reactHotLoader.register(StyledAnchor, "StyledAnchor", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/index.js");
  reactHotLoader.register(AppMenu, "AppMenu", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/index.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/AppMenu/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();